import { Button } from '@/components/ui/button'
import { Link } from 'wouter'
import { PencilIcon } from 'lucide-react'
import { SettingItem, SettingItemDesc } from '../settingsItems'
import SettingsCardShell from "../SettingsCardShell"
import type { SettingsCardProps } from "../utils"


//The templates live in their own pages, so this card only links to them
const templatePages = [
    {
        label: 'Admin Jail Templates',
        href: '/settings/admin-jail-templates',
        desc: 'Configure admin jail reasons and durations that will appear as dropdown options in the player modal.',
    },
    {
        label: 'Ban Templates',
        href: '/settings/ban-templates',
        desc: 'Configure ban reasons and durations that will appear as dropdown options when banning a player. This is useful for common reasons that happen frequently, like violation of your server rules.',
    },
    {
        label: 'Warn Templates',
        href: '/settings/warn-templates',
        desc: 'Configure warn reasons that will appear as dropdown options when warning a player.',
    },
];


export default function ConfigCardTemplates({ cardCtx, pageCtx }: SettingsCardProps) {
    return (
        <SettingsCardShell
            cardCtx={cardCtx}
            pageCtx={pageCtx}
            onClickSave={() => { }}
            hideSaveButton
        >
            {templatePages.map((page) => (
                <SettingItem key={page.href} label={page.label}>
                    <Link asChild href={page.href}>
                        <Button
                            size={'sm'}
                            variant="secondary"
                            disabled={pageCtx.isReadOnly}
                        >
                            <PencilIcon className='size-4 mr-1.5 inline-block' /> Edit {page.label}
                        </Button>
                    </Link>
                    <SettingItemDesc>
                        {page.desc}
                    </SettingItemDesc>
                </SettingItem>
            ))}
        </SettingsCardShell>
    )
}
